import { Background, Slider } from './Drawer.parts';
import type { DrawerProps } from './Drawer.types';

export * from './Drawer.types';

export function Drawer(props: DrawerProps) {
	return (
		<Background {...props} onClick={props.onClose}>
			<Slider
				{...props}
				onClick={(e) => {
					// Stop clicks going to the overlay
					e.stopPropagation();
				}}
			>
				{props.children}
			</Slider>
		</Background>
	);
}
